import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogRef } from '../dialog-ref';

@Component({
    selector: 'ihd-dialog-alert',
    templateUrl: './dialog-alert.component.html',
    host: {
        'class': 'c-dialog active alert c-dialog--gutter-xlg',
        '[class.c-dialog--icon]': 'config.icon && config.icon.length > 0',
        '[class.c-dialog--sm]': 'config.small',
        '[class.c-dialog--lg]': '!config.small',
        '[class.in]': 'isReady'
    }
})
export class DialogAlertComponent implements OnInit {
    public config;
    public isReady: boolean = false;
    public isBusy: boolean = false;

    constructor(public dialogRef: DialogRef<DialogAlertComponent>,
                private cdr: ChangeDetectorRef) {
        this.config = dialogRef.containerInstance.config;
    }

    ngOnInit() {
        this.isReady = true;
        this.cdr.markForCheck();
    }

    /**
     * Process confirmed request and close.
     */
    process() {
        this.isBusy = true;
        this.cdr.detectChanges();

        if (this.config.process) {
            this.config.process();
        }

        this.dialogRef.close(true);
    }
}
